const title = process.env.VUE_APP_BASE_NAME || 'INSURFORCE保险科技平台';
export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle}-${title}`;
  }
  return title;
}